import React from "react";

const Loading = () => {
  // return <div>Checking new version</div>;
  return <div></div>; // as per request its removed  @developer deviprasadmg@navneettoptech.com
};

export default Loading;
